import React, {useContext} from 'react'
import Page from '../page/page'
import {AppContext} from '../app/app'
import LinearProgress, {
    linearProgressClasses,
} from '@mui/material/LinearProgress'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

import './load-splash.css'

const LoadSplash = ({hide}) => {
    const {gameLoadingPercent} = useContext(AppContext)

    return (
        <div className={`load-splash${hide ? ' load-splash--hide' : ''}`}>
            <Page className="splash">
                <Box sx={{mt: '25vh'}}>
                    <Typography
                        variant="h6"
                        sx={{textAlign: 'center', fontWeight: 'bold'}}
                    >{`${gameLoadingPercent}%`}</Typography>
                </Box>
                <Box
                    sx={{
                        mt: 1,
                        mb: 1,
                    }}
                >
                    <LinearProgress
                        variant="determinate"
                        value={gameLoadingPercent}
                        sx={{
                            height: 10,
                            borderRadius: 5,
                            [`&.${linearProgressClasses.colorPrimary}`]: {
                                backgroundColor: '#490ec0',
                            },
                            [`& .${linearProgressClasses.bar}`]: {
                                borderRadius: 5,
                                backgroundColor: '#ffffff',
                            },
                        }}
                    />
                </Box>
                <Box>
                    <Typography
                        variant="h6"
                        sx={{textAlign: 'center', fontWeight: 'bold'}}
                    >
                        Launching...
                    </Typography>
                </Box>
            </Page>
        </div>
    )
}

export default LoadSplash
